import { useState } from "react";
import { AlertTriangle, Eye } from "lucide-react";
import { PriceDiffDialog } from "@/components/PriceDiffDialog";

export const PriceAlert = ({ quote, isAdmin, onUpdated }) => {
  const [open, setOpen] = useState(false);
  if (!quote.price_changed) return null;
  const changes = quote.price_changes || [];

  return (
    <span className="inline-flex items-center gap-1.5 mt-1" onClick={(e) => e.stopPropagation()}>
      <span data-testid={`price-alert-${quote.id}`}
        className="inline-flex items-center gap-1 text-[11px] font-semibold text-amber-700 bg-amber-50 border border-amber-200 px-1.5 py-0.5 rounded">
        <AlertTriangle className="h-3 w-3" /> Precios cambiados ({changes.length})
      </span>
      <button data-testid={`price-view-${quote.id}`} onClick={() => setOpen(true)}
        className="inline-flex items-center gap-1 text-[11px] font-semibold text-slate-600 hover:text-slate-900 transition-colors">
        <Eye className="h-3 w-3" /> Ver cambios
      </button>
      <PriceDiffDialog quoteId={quote.id} open={open} onOpenChange={setOpen} isAdmin={isAdmin} onUpdated={onUpdated} />
    </span>
  );
};
